import React from 'react';
import MuiList from '@mui/material/List';

const List = (props) => <MuiList {...props} />;

export default List;
